/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function CheckmarkIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "checkmark", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M5.5 12.5L10.5 17.5L20 8", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(CheckmarkIcon);
export default ForwardRef;
//# sourceMappingURL=checkmarkIcon.js.map